const CloseSocialOverlay = () => {
  return (document.getElementById("nav-soc-overlay").style.left = "100%");
};

export default CloseSocialOverlay;
